import Dashboard from 'features/orderManagement/Dashboard';

export function AllOrdersContent() {
  return <Dashboard pageHeader="All Orders" useHeaderDivider={false} showHeaderElipsis={false} />;
}
